import React from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from '../components/ui/PageHeader';
import { SectionHeading } from '../components/ui/SectionHeading';
import { Card, CardContent } from '../components/ui/Card';
import { Heart, ShieldCheck, Scale, Users, ArrowRight, PlayCircle, Quote } from 'lucide-react';
import { Badge } from '../components/ui/Badge';
import { Button } from '../components/ui/Button';
import { CFA_INFO } from '../data/constants';
import { QualiopiTeaser } from '../components/QualiopiTeaser';
export function CFA() {
  return <div className="flex flex-col w-full" data-id="element-916" data-mp="zwbv6gajviih">
      <PageHeader title="L'esprit Zillenium" subtitle="Plus qu'un CFA, un véritable tremplin vers votre avenir professionnel." data-id="element-917" data-mp="1dus2o9g8ld1o" />

      <div className="flex flex-col w-full" data-id="element-918" data-mp="18x0cbjv8pyzl">
        {/* Intro & CTA */}
        <section className="py-16 bg-white text-center" data-id="element-919" data-mp="2p72o1usni6w3">
          <div className="container max-w-3xl mx-auto" data-id="element-920" data-mp="2kam0b1pd5ujj">
            <h2 className="text-3xl md:text-4xl font-extrabold font-heading text-primary-dark mb-6" data-id="element-921" data-mp="2kbx6t9a71gec">
              L'alternance autrement.
            </h2>
            <p className="text-xl text-muted-foreground leading-relaxed mb-10" data-id="element-922" data-mp="3vsxpfgqiegtw">
              Chez Zillenium, nous ne formons pas de simples étudiants, mais les
              professionnels de demain. Notre pédagogie repose sur l'action, la
              confiance et un accompagnement sur-mesure.
            </p>
            <Button size="lg" className="bg-brand-orange hover:bg-[#E67E22] text-white text-lg px-8 py-6 shadow-xl group" asChild data-id="element-923" data-mp="385xx0qp7ed32">
              <Link to="/candidater" className="flex items-center" data-id="element-924" data-mp="3i1j1qwlnprgi">
                Rejoindre Zillenium
                <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-925" data-mp="3mu2ghww2ysmw" />
              </Link>
            </Button>
          </div>
        </section>

        {/* Le Coeur du CFA : Justine & Le Directeur */}
        <section className="py-24 bg-muted relative overflow-hidden" data-id="element-926" data-mp="2uavhdbuk19d2">
          <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary rounded-full blur-[120px] opacity-10 pointer-events-none" data-id="element-927" data-mp="2maz7uecbfr4l" />
          <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-brand-orange rounded-full blur-[100px] opacity-10 pointer-events-none" data-id="element-928" data-mp="2w23p5kpgro2l" />

          <div className="container max-w-6xl mx-auto relative z-10" data-id="element-929" data-mp="2r41xwchvwig1">
            <SectionHeading title="Ceux qui font Zillenium" subtitle="Découvrez la vision et l'énergie de notre équipe dirigeante et pédagogique." centered data-id="element-930" data-mp="23cwexognda1i" />

            <div className="grid md:grid-cols-2 gap-12 mt-16" data-id="element-931" data-mp="2dbvpjckz3fr5">
              {/* Le Directeur */}
              <Card className="border-none shadow-2xl bg-white overflow-hidden group hover:-translate-y-2 transition-transform duration-500" data-id="element-932" data-mp="28c9bj0xblvha">
                <div className="h-3 w-full bg-brand-orange" data-id="element-933" data-mp="3ooxyblgtz10r" />
                <CardContent className="p-8 md:p-10 flex flex-col h-full" data-id="element-934" data-mp="3jqmlr2z5iceu">
                  <div className="mb-8 text-center" data-id="element-935" data-mp="3rbgsetlcw85g">
                    <h3 className="font-extrabold font-heading text-3xl text-primary-dark mb-3" data-id="element-936" data-mp="3r9vwazje8h5h">
                      {CFA_INFO.president}
                    </h3>
                    <Badge className="bg-lavande text-primary-dark hover:bg-lavande/80 border-none px-4 py-1.5 text-sm" data-id="element-937" data-mp="3ibk7n3237tfo">
                      Directeur & Fondateur
                    </Badge>
                  </div>
                  <div className="relative rounded-[2rem] overflow-hidden bg-slate-100 aspect-[9/16] shadow-inner ring-4 ring-slate-50" data-id="element-938" data-mp="dxlpbjue4f86">
                    <iframe src="https://www.instagram.com/reel/DVOBbA0DIMk/embed" title="Mot du directeur" className="absolute inset-0 w-full h-full" frameBorder="0" scrolling="no" allowTransparency={true} data-id="element-939" data-mp="ix82xue4rxhi"></iframe>
                  </div>
                </CardContent>
              </Card>

              {/* Justine */}
              <Card className="border-none shadow-2xl bg-white overflow-hidden group hover:-translate-y-2 transition-transform duration-500" data-id="element-940" data-mp="3a4iows08u818">
                <div className="h-3 w-full bg-primary" data-id="element-941" data-mp="304i4t3ujvnvz" />
                <CardContent className="p-8 md:p-10 flex flex-col h-full" data-id="element-942" data-mp="3051ooq3rgmcn">
                  <div className="mb-8 text-center" data-id="element-943" data-mp="2w47x9mr40pf0">
                    <h3 className="font-extrabold font-heading text-3xl text-primary-dark mb-3" data-id="element-944" data-mp="3stfmb4qxtgno">
                      Justine Delille
                    </h3>
                    <div className="flex flex-wrap justify-center gap-2" data-id="element-945" data-mp="3nuvyeyss9uso">
                      <Badge className="bg-primary/10 text-primary hover:bg-primary/20 border-none px-4 py-1.5 text-sm" data-id="element-946" data-mp="3j2knz20f2qlv">
                        Responsable pédagogique
                      </Badge>
                    </div>
                  </div>
                  <div className="relative rounded-[2rem] overflow-hidden bg-slate-100 aspect-[9/16] shadow-inner ring-4 ring-slate-50" data-id="element-947" data-mp="fgnaw554bu7d">
                    <iframe src="https://www.instagram.com/reel/DVQg1eADa3_/embed" title="Mot de la responsable pédagogique" className="absolute inset-0 w-full h-full" frameBorder="0" scrolling="no" allowTransparency={true} data-id="element-948" data-mp="1tb3t0oxl42tf"></iframe>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </section>

        {/* Mot du fondateur */}
        <section className="py-24 bg-white relative overflow-hidden" data-id="element-949" data-mp="2h6ydg7pzk406">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[700px] bg-lavande rounded-full blur-[120px] opacity-40 pointer-events-none" data-id="element-950" data-mp="2m0aspr8ryyg9" />
          <div className="container max-w-4xl mx-auto relative z-10" data-id="element-951" data-mp="2uzxvagd8qaaw">
            <div className="text-center mb-12" data-id="element-952" data-mp="2v1r4o3f8n8ml">
              <span className="inline-block text-sm font-bold uppercase tracking-widest text-brand-orange mb-4" data-id="element-953" data-mp="2zyhi0iznrq4b">
                Le mot du fondateur
              </span>
              <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-primary-dark tracking-tight" data-id="element-954" data-mp="zuez19en0ra7">
                L'alternance autrement
              </h2>
            </div>

            <Card className="border-none shadow-2xl bg-white overflow-hidden" data-id="element-955" data-mp="19onotpcaa64o">
              <div className="h-2 w-full bg-brand-orange" data-id="element-956" data-mp="14u9rvihz3qxw" />
              <CardContent className="p-8 md:p-14" data-id="element-957" data-mp="1impw2mmm1v0e">
                <Quote className="w-12 h-12 text-lavande mb-6" data-id="element-958" data-mp="1ilfzk1veouvv" />

                <p className="text-xl md:text-2xl font-bold font-heading text-primary-dark leading-snug mb-8" data-id="element-959" data-mp="1ekmah5689a1e">
                  Chez Zillenium Alternance, nous ne formons pas seulement des
                  apprenants : nous accompagnons des parcours de vie.
                </p>

                <div className="space-y-6 text-lg text-muted-foreground leading-relaxed" data-id="element-960" data-mp="3uca6mydf2yj5">
                  <p data-id="element-961" data-mp="3pe8l86siqn4i">
                    L'alternance est une étape importante. Pour un jeune, c'est
                    souvent le premier vrai contact avec le monde professionnel,
                    ses exigences, ses codes, ses responsabilités, mais aussi
                    ses opportunités. Pour une entreprise, c'est un engagement
                    fort : accueillir, former, transmettre et faire grandir un
                    futur professionnel.
                  </p>
                  <p data-id="element-962" data-mp="1m56kwqgso2dv">
                    Notre mission est de créer les conditions d'une
                    collaboration réussie entre trois acteurs essentiels :{' '}
                    <span className="font-semibold text-primary-dark" data-id="element-963" data-mp="1r5kx8kpfhyhp">
                      l'apprenant, l'entreprise et le CFA.
                    </span>
                  </p>
                  <p data-id="element-964" data-mp="1h6vd0la281ya">
                    Nous accompagnons chaque jeune dans sa progression, sa
                    posture professionnelle, sa recherche d'entreprise, sa
                    confiance en lui et sa capacité à trouver sa place. Nous
                    savons que derrière chaque parcours, il peut y avoir des
                    doutes, des freins, des difficultés personnelles, sociales
                    ou psychologiques. C'est pourquoi notre accompagnement ne se
                    limite pas à la formation : il repose sur l'écoute, la
                    proximité, le suivi et la confiance.
                  </p>
                  <p data-id="element-965" data-mp="1kk0x2jr3qga6">
                    Nous accompagnons également les entreprises dans
                    l'intégration de leurs alternants, afin de sécuriser le
                    parcours, faciliter la communication et construire une
                    relation durable. Notre rôle est d'être un lien permanent
                    entre le jeune, l'employeur et l'équipe pédagogique.
                  </p>
                  <p data-id="element-966" data-mp="30zv6mcvrqbm7">
                    Chez Zillenium Alternance, nous sommes sur le terrain,
                    proches des jeunes, des familles, des entreprises et des
                    partenaires locaux. Nous comprenons les réalités de notre
                    territoire, les enjeux de l'insertion professionnelle et les
                    besoins d'accompagnement humain.
                  </p>
                  <p className="font-semibold text-primary-dark" data-id="element-967" data-mp="3d9t6pj84r39c">
                    Rejoindre Zillenium Alternance, c'est intégrer un CFA qui
                    forme, accompagne et reste présent à chaque étape du
                    parcours.
                  </p>
                </div>

                <div className="mt-10 pt-8 border-t border-slate-100 flex items-center gap-4" data-id="element-968" data-mp="2pkidcmt40b58">
                  <div className="w-14 h-14 rounded-2xl bg-primary flex items-center justify-center text-white font-extrabold font-heading text-xl shrink-0" data-id="element-969" data-mp="2ujv3bgfa1yc1">
                    SM
                  </div>
                  <div data-id="element-970" data-mp="9tw53yo1b3mm">
                    <p className="font-extrabold font-heading text-lg text-primary-dark leading-tight" data-id="element-971" data-mp="9skrl74sehib">
                      Samir MOKEDDEM
                    </p>
                    <p className="text-brand-orange font-semibold text-sm" data-id="element-972" data-mp="1dlnc7k37n5qx">
                      Fondateur & Directeur — Zillenium Alternance
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </section>

        {/* Valeurs Visuelles (Compact) */}
        <section className="py-24 bg-white" data-id="element-973" data-mp="1rc0jrlc6wifq">
          <div className="container max-w-5xl mx-auto" data-id="element-974" data-mp="1rf6d5cruq6h9">
            <SectionHeading title="Notre ADN en 4 mots" centered className="mb-16" data-id="element-975" data-mp="unukldy1ei8u" />
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-976" data-mp="yqh7r1jrjezp">
              <div className="flex flex-col items-center text-center group" data-id="element-977" data-mp="13mptwywdo8gd">
                <div className="w-20 h-20 bg-lavande rounded-3xl flex items-center justify-center mb-6 group-hover:-translate-y-2 transition-transform duration-300" data-id="element-978" data-mp="18mu8ukhn0v4h">
                  <Heart className="w-10 h-10 text-primary" data-id="element-979" data-mp="2k1r10394c0g2" />
                </div>
                <h4 className="font-bold text-xl text-primary-dark mb-2" data-id="element-980" data-mp="2k3tzlboc71we">
                  Bienveillance
                </h4>
                <p className="text-sm text-muted-foreground" data-id="element-981" data-mp="3fkp04a1gnw4">
                  Un cadre humain et exigeant.
                </p>
              </div>
              <div className="flex flex-col items-center text-center group" data-id="element-982" data-mp="3usdzcdskb7p9">
                <div className="w-20 h-20 bg-brand-orange/10 rounded-3xl flex items-center justify-center mb-6 group-hover:-translate-y-2 transition-transform duration-300" data-id="element-983" data-mp="3ptubg7uerlu9">
                  <ShieldCheck className="w-10 h-10 text-brand-orange" data-id="element-984" data-mp="3guh1le2dgv90" />
                </div>
                <h4 className="font-bold text-xl text-primary-dark mb-2" data-id="element-985" data-mp="3buuk2sfigsue">
                  Confiance
                </h4>
                <p className="text-sm text-muted-foreground" data-id="element-986" data-mp="36wt085a9gphv">
                  Valoriser chaque réussite.
                </p>
              </div>
              <div className="flex flex-col items-center text-center group" data-id="element-987" data-mp="1a1n6bnfjqjam">
                <div className="w-20 h-20 bg-primary/10 rounded-3xl flex items-center justify-center mb-6 group-hover:-translate-y-2 transition-transform duration-300" data-id="element-988" data-mp="15566vx2wcii8">
                  <Scale className="w-10 h-10 text-primary" data-id="element-989" data-mp="34bv28r7p79d5" />
                </div>
                <h4 className="font-bold text-xl text-primary-dark mb-2" data-id="element-990" data-mp="2pmyukv9jzyd2">
                  Responsabilité
                </h4>
                <p className="text-sm text-muted-foreground" data-id="element-991" data-mp="2umtluzx8qpyn">
                  Devenir autonome et fiable.
                </p>
              </div>
              <div className="flex flex-col items-center text-center group" data-id="element-992" data-mp="3i9jr0a4vz0nh">
                <div className="w-20 h-20 bg-lavande rounded-3xl flex items-center justify-center mb-6 group-hover:-translate-y-2 transition-transform duration-300" data-id="element-993" data-mp="3n9o5xvq5bnbl">
                  <Users className="w-10 h-10 text-primary" data-id="element-994" data-mp="3db8f7tv16g2m" />
                </div>
                <h4 className="font-bold text-xl text-primary-dark mb-2" data-id="element-995" data-mp="1xuzupxtakbf5">
                  Collectif
                </h4>
                <p className="text-sm text-muted-foreground" data-id="element-996" data-mp="21xw736s8nban">
                  L'esprit d'équipe avant tout.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* BDE Teaser */}
        <section className="py-16 bg-primary-dark text-white relative overflow-hidden" data-id="element-997" data-mp="1pe8waecmz0wj">
          <div className="absolute top-1/2 right-0 -translate-y-1/2 translate-x-1/4 w-[400px] h-[400px] bg-brand-orange rounded-full blur-[100px] opacity-30 pointer-events-none" data-id="element-998" data-mp="24b9jq5nso9p7" />
          <div className="container max-w-4xl mx-auto relative z-10" data-id="element-999" data-mp="1bo5fw40fu1f0">
            <div className="flex flex-col md:flex-row items-center justify-between gap-8 bg-white/5 p-8 md:p-12 rounded-[2rem] border border-white/10 backdrop-blur-sm" data-id="element-1000" data-mp="16oj6k5nqd5bh">
              <div className="text-center md:text-left" data-id="element-1001" data-mp="1leqfnurulbzi">
                <h3 className="font-extrabold font-heading text-3xl mb-4" data-id="element-1002" data-mp="1glf4jhg0691s">
                  La vie étudiante
                </h3>
                <p className="text-lavande text-lg max-w-md" data-id="element-1003" data-mp="sui3x0tnqy5u">
                  Découvrez le BDE Zillenium : des projets solidaires, des
                  événements fédérateurs et une ambiance unique.
                </p>
              </div>
              <Button size="lg" className="bg-white hover:bg-lavande text-primary-dark text-lg px-8 shrink-0 group" asChild data-id="element-1004" data-mp="3rcm7f6o06voa">
                <Link to="/bde" className="flex items-center" data-id="element-1005" data-mp="4x9jk18oqcvz">
                  Découvrir le BDE
                  <PlayCircle className="w-5 h-5 ml-2 group-hover:scale-110 transition-transform" data-id="element-1006" data-mp="9ww5cz2kx1ge" />
                </Link>
              </Button>
            </div>
          </div>
        </section>

        {/* Qualiopi */}
        <section className="py-24 bg-lavande relative overflow-hidden" data-id="element-1007" data-mp="ix2i2iqgdxei">
          <div className="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-white rounded-full blur-[120px] opacity-60 pointer-events-none" data-id="element-1008" data-mp="nwf5b4l8l6hm" />
          <div className="container max-w-6xl relative z-10" data-id="element-1009" data-mp="2kqs1fayyzxiv">
            <QualiopiTeaser data-id="element-1010" data-mp="2potkhvwebwuc" />
          </div>
        </section>
      </div>
    </div>;
}